import styled from "styled-components";
import Trashcan from "../../images/PMB_trashcan.png";

export const DeleteButton = styled.button`
  height: 80px;
  width: 80px;
  background-color: transparent;
  border: none;
  background-image: url(${Trashcan});
  background-repeat: no-repeat;
  background-size: 32px 32px;
  background-position: center;
`;
